import React, { useState } from "react";
import { CATALOGO, ESPECIALIDADES } from "../../../../services/cuestionariocatalog";


const Bloque = ({ titulo, resumen, children, tieneDatos }) => {
  const [abierto, setAbierto] = useState(false);

  return (
    <div className="antecedente-bloque">
      <div
        className="antecedente-header"
        onClick={() => setAbierto(!abierto)}
      >
        <div className="antecedente-titulo">
          {titulo}
          {tieneDatos ? (
            <span className="antecedente-badge activo">Con datos</span>
          ) : (
            <span className="antecedente-badge">Sin datos</span>
          )}
        </div>
        <div className="antecedente-resumen">
          {resumen || "—"}
        </div>
      </div>

      {abierto && (
        <div className="antecedente-contenido">
          {children}
        </div>
      )}
    </div>
  );
};

const InterrogatorioPaciente = ({ historiaClinica, onEditar, readOnly = false }) => {
  
  
    // Consolidados (modo breve) — si existen, prioridad sobre individuales
  const heredoConsolidado = historiaClinica?.heredofamiliares_consolidado;
  const noPatConsolidado = historiaClinica?.no_patologicos_consolidado;
  const patConsolidado = historiaClinica?.patologicos_consolidado;
  const interrogatorioConsolidado = historiaClinica?.interrogatorio_consolidado;
  const hasConsolidado = (v) => v != null && String(v).trim() !== "";

  // HEREDOFAMILIARES
  const heredo = hasConsolidado(heredoConsolidado)
    ? { "Antecedentes heredo-familiares": heredoConsolidado }
    : {
    Madre: historiaClinica?.["antecedentes.heredoFamiliares.madre"],
    Padre: historiaClinica?.["antecedentes.heredoFamiliares.padre"],
    Hermanos: historiaClinica?.["antecedentes.heredoFamiliares.hermanos"],
    Abuelos: historiaClinica?.["antecedentes.heredoFamiliares.abuelos"],
    Otros: historiaClinica?.["antecedentes.heredoFamiliares.otros"],
  };

   // NO PATOLÓGICOS — grupo_etnico siempre visible
  const grupoEtnico = historiaClinica?.grupo_etnico;
  const noPat = hasConsolidado(noPatConsolidado)
    ? {
        ...(grupoEtnico ? { "Grupo étnico": grupoEtnico } : {}),
        "Antecedentes no patológicos": noPatConsolidado,
      }
    : {
        ...(grupoEtnico ? { "Grupo étnico": grupoEtnico } : {}),
    Origen: historiaClinica?.["antecedentes.personalesNoPatologicos.Origen"],
    Ocupación: historiaClinica?.["antecedentes.personalesNoPatologicos.ocupacion"],
    Escolaridad: historiaClinica?.["antecedentes.personalesNoPatologicos.escolaridad"],
    Religión: historiaClinica?.["antecedentes.personalesNoPatologicos.religion"],
    Mascotas: historiaClinica?.["antecedentes.personalesNoPatologicos.mascotas"],
    Viajes: historiaClinica?.["antecedentes.personalesNoPatologicos.viajes"],
    Alimentación: historiaClinica?.["antecedentes.personalesNoPatologicos.alimentacion"],
    Vivienda: historiaClinica?.["antecedentes.personalesNoPatologicos.vivienda"],
    Otros: historiaClinica?.["antecedentes.personalesNoPatologicos.otros"],
  };

  // PATOLÓGICOS — ECD, alergias, hemotipo siempre visibles
  const camposFijosPat = {
    "Enfermedades Crónico-Degenerativas": historiaClinica?.["antecedentes.personalesPatologicos.ECD"],
    Alergias: historiaClinica?.["antecedentes.personalesPatologicos.alergias"],
    Hemotipo: historiaClinica?.["antecedentes.personalesPatologicos.hemotipo"],
  };
  const pat = hasConsolidado(patConsolidado)
    ? { ...camposFijosPat, "Antecedentes patológicos": patConsolidado }
    : {
        ...camposFijosPat, 
    Quirúrgicos: historiaClinica?.["antecedentes.personalesPatologicos.quirurgicos"],
    Traumáticos: historiaClinica?.["antecedentes.personalesPatologicos.traumaticos"],
    Hospitalizaciones: historiaClinica?.["antecedentes.personalesPatologicos.hospitalizaciones"],
    Infectocontagiosos: historiaClinica?.["antecedentes.personalesPatologicos.infectocontagiosos"],
    Transfusionales: historiaClinica?.["antecedentes.personalesPatologicos.transfusionales"],
    Exantemáticos: historiaClinica?.["antecedentes.personalesPatologicos.exantematicos"],
    Alcohol: historiaClinica?.["antecedentes.personalesPatologicos.alcohol"],
    Tabaco: historiaClinica?.["antecedentes.personalesPatologicos.tabaco"],
    Toxicomanías: historiaClinica?.["antecedentes.personalesPatologicos.toxicomanias"],
    Vacunación: historiaClinica?.["antecedentes.personalesPatologicos.vacunacion"],
    "Gineco-Obstétricos / Andrológicos":
      historiaClinica?.["antecedentes.personalesPatologicos.ginecoObstetricosAndrologicos"],
    Otros: historiaClinica?.["antecedentes.personalesPatologicos.otros"],
  };

   // PADECIMIENTO ACTUAL — no tiene consolidado
 const padecimientoActual = {
  "Padecimiento actual": historiaClinica?.padecimientoActual,
 };

  // INTERROGATORIO — sintomaticoRespiratorioTb siempre visible
  const sintomaticoTb = historiaClinica?.sintomaticoRespiratorioTb;
  const interrogatorio = hasConsolidado(interrogatorioConsolidado)
    ? {
        ...(sintomaticoTb ? { "Sintomático respiratorio TB": sintomaticoTb } : {}),
        "Interrogatorio por aparatos y sistemas": interrogatorioConsolidado,
      }
    : {
        ...(sintomaticoTb ? { "Sintomático respiratorio TB": sintomaticoTb } : {}),
  "Sistema nervioso": historiaClinica?.sistema_nervioso,
  "Sistema cardiovascular": historiaClinica?.sistema_cardiovascular,
  "Sistema respiratorio": historiaClinica?.sistema_respiratorio,
  "Sistema digestivo": historiaClinica?.sistema_digestivo,
  "Sistema genitourinario": historiaClinica?.sistema_genitourinario,
  "Sistema musculoesquelético": historiaClinica?.sistema_musculoesqueletico,
  "Sistema endocrino": historiaClinica?.sistema_endocrino,
  "Sistema hematológico": historiaClinica?.sistema_hematologico,
  "Piel y anexos": historiaClinica?.piel_anexos,
  };

  const tieneDatos = (obj) =>
    obj && Object.values(obj).some((v) => v);

  const resumenSimple = (obj) =>
    obj
      ? Object.entries(obj)
          .filter(([, v]) => v)
          .slice(0, 3)
          .map(([k]) => k)
          .join(" · ")
      : "";

  const renderObj = (obj) =>
    Object.entries(obj || {}).map(([k, v]) => (
      <div className="antecedente-item" key={k}>
        <span className="antecedente-label">{k}</span>
        <span className="antecedente-valor">
          {v != null && String(v).trim() !== "" ? String(v) : ""}
        </span>
      </div>
    ));

  // ===============================
  // Cuestionarios iniciales (NO recurrentes)
  // ===============================
  const selectedKeysHistoria = Array.isArray(
    historiaClinica?.config_cuestionario?.custom?.historia?.selected_keys
  )
    ? new Set(historiaClinica.config_cuestionario.custom.historia.selected_keys)
    : null;

  // Normaliza preguntas (igual que en captura)
  const mapQuestions = (arr = []) =>
    (arr || []).map((q) => ({
      ...q,
      name: q.name || q.key,
      type: q.type || (q.tipo === "boolean" ? "switch" : q.tipo),
    }));

  // Todas las preguntas posibles (todas las especialidades)
  const preguntasDeTodas = ESPECIALIDADES.flatMap((esp) =>
    mapQuestions(CATALOGO[esp] || [])
  );

  // Selección final (NUNCA dejar fuera ninguna)
  const preguntasHistoria = selectedKeysHistoria
    ? preguntasDeTodas.filter((q) => selectedKeysHistoria.has(q.name))
    : [];

  // Gateos dependientes (igual que en captura)
  const preguntasHistoriaFiltradas = preguntasHistoria.filter((q) => {
    if (q.name === "longitud" && !historiaClinica?.es_longitud) return false;
    if (
      q.name === "detalle_caidas_12_meses" &&
      !historiaClinica?.caidas_ultimos_12_meses
    )
      return false;
    return true;
  });
  
  const hayRespuestasCuestionario = preguntasHistoriaFiltradas.some((q) => {
    const v = historiaClinica?.[q.name];
    return v !== undefined && v !== null && String(v).trim() !== "";
  });

  return (
    <section className="paciente-folder antecedentes-paciente">
      <div className="antecedentes-header">
        <h2>Interrogatorio</h2>
         {historiaClinica && !readOnly && (
        <button
            className="btn-editar-datos"
            onClick={onEditar}
            type="button"
        >
            Editar
        </button>
        )}
      </div>
      
      <Bloque
        titulo="▾ Antecedentes heredo-familiares"
        resumen={resumenSimple(heredo)}
        tieneDatos={tieneDatos(heredo)}
      >
        {renderObj(heredo)}
      </Bloque>

      <Bloque
        titulo="▾ Antecedentes personales no patológicos"
        resumen={resumenSimple(noPat)}
        tieneDatos={tieneDatos(noPat)}
      >
        {renderObj(noPat)}
      </Bloque>

      <Bloque
        titulo="▾ Antecedentes personales patológicos"
        resumen={resumenSimple(pat)}
        tieneDatos={tieneDatos(pat)}
      >
        {renderObj(pat)}
      </Bloque>
      <Bloque
        titulo="▾ Padecimiento actual"
        resumen={resumenSimple(padecimientoActual)}
        tieneDatos={tieneDatos(padecimientoActual)}
      >
        {renderObj(padecimientoActual)}
      </Bloque>
      <Bloque
        titulo="▾ Interrogatorio por aparatos y sistemas"
        resumen={resumenSimple(interrogatorio)}
        tieneDatos={tieneDatos(interrogatorio)}
      >
        {renderObj(interrogatorio)}
      </Bloque>
      {/* ===============================
          Evaluaciones iniciales / Cuestionarios
      =============================== */}
      {hayRespuestasCuestionario && (
      <Bloque
        titulo="▾ Cuestionario por especialidad"
        resumen=""
        tieneDatos
      >
        {preguntasHistoriaFiltradas.map((q) => {
          const valor = historiaClinica?.[q.name];

          if (valor === undefined || valor === null || String(valor).trim() === "")
            return null;

          return (
            <div key={q.name} className="campo-clinico">
              <strong>{q.label}:</strong>{" "}
              {typeof valor === "boolean" ? (valor ? "Sí" : "No") : valor}
            </div>
          );
        })}
      </Bloque>
    )}

    </section>
  );
};

export default InterrogatorioPaciente;
